export default __webpack_public_path__ + "static/media/augustine.972ca81c.jpeg";